import { InstallationHelp } from './components/InstallationHelp'
import { InstallationModal } from './components/InstallationModal'
import { NotificationPopup } from './components/NotificationPopup'
import { PromotionPopup } from './components/PromotionPopup'
import { PwaProvider, usePwaContext } from './context'
import { Toggle } from './Toggle'

export const PwaClient = {
  Provider: PwaProvider,
  use: usePwaContext,
  Toggle,
  PromotionPopup,
  InstallationHelp,
  InstallationModal,
  NotificationPopup,
}
